import React from 'react';

import Text from 'components/shared/Typography/Text';

import s from './index.module.css';

export function GeneralInfoTooltip() {
  return (
    <Text accent className={s.tooltip}>
      <b>Tool Tip:</b>
      <p className={s.tooltipDescription}>
        Files serve as centralized hubs for all information related to a specific inquiry.
      </p>
      <b>For example:</b>
      <ul>
        <li>
          <Text className={s.tooltipText} italic>
            West x 5, Italy, July 2026
          </Text>
        </li>
        <li>
          <Text className={s.tooltipText} italic>
            West x 7, France, August 2027 (a separate trip for the same clients)
          </Text>
        </li>
      </ul>
      <p>Each File can contain multiple proposals or different versions.</p>
    </Text>
  );
}
